import React, { useEffect } from "react";
import "./Trailers.css";
import AOS from "aos";
import "aos/dist/aos.css";
const trailer1 = "/assets/trailers/trailer1.mp4";
const trailer2 = "/assets/trailers/trailer2.mp4";
const trailer3 = "/assets/trailers/trailer3.mp4";
const trailer4 = "/assets/trailers/trailer4.mp4";
const trailer5 = "/assets/trailers/trailer5.mp4";
const trailer6 = "/assets/trailers/trailer6.mp4";
const trailer7 = "/assets/trailers/trailer7.mp4";
const trailer8 = "/assets/trailers/trailer8.mp4";
const trailer9 = "/assets/trailers/trailer9.mp4";
const trailer10 = "/assets/trailers/trailer10.mp4";
const trailer11 = "/assets/trailers/trailer11.mp4";
const trailer12 = "/assets/trailers/trailer12.mp4";


const videos = [
    { id: 1, src: trailer1, title: "💍 Golden Hour Magic" },
    { id: 2, src: trailer2, title: "🌸 Cultural Wedding Vibes" },
    { id: 3, src: trailer3, title: "💫 Modern Love Story" },
    { id: 4, src: trailer4, title: "🌸 Elegant Wedding Moments" },
    { id: 5, src: trailer5, title: "✨ Eternal Love Moments" },
    { id: 6, src: trailer6, title: "🔔 Traditional Bliss" },
    { id: 7, src: trailer7, title: "🌿 Romantic Wedding" },
    { id: 8, src: trailer8, title: "🌹 Cinematic Memories"  },
    { id: 9, src: trailer9, title: "💎 Forever Begins Here" },
    { id: 10, src: trailer10, title: "💫 Intimate Couple Shoot" },
    { id: 11, src: trailer11, title: "💫 Elegant Wedding Symphony"},
    { id: 12, src: trailer12, title: "🔔 A Tale of Two Hearts" },
];

const Trailers = () => {

    useEffect(() => {
          AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
            disable: 'mobile' // disable on mobile devices
          });
        }, []);

  return (
    <div className="trailers-container">
      <h2 className="trailers-title">Wedding Trailers</h2>
      <p className="trailers-description">
        Relive the emotions, laughter, and joy through these beautifully captured wedding moments.  
        Each trailer tells a unique love story filled with unforgettable memories 💍✨
      </p>

      <div className="trailers-grid" data-aos="zoom-out">
        {videos.map((video) => (
          <div key={video.id} className="trailer-card">
            <video controls className="trailer-video">
              <source src={video.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h4 className="trailer-title">{video.title}</h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Trailers;
